import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/nft/phone-1.webp")